import React, {Component} from "react";
import {ff, form} from "@mc/mc-legacy";
import {Button, Card, CardBody, Label} from "reactstrap";
import {FormErrors, reduxForm} from "redux-form";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";

type FormData = { ico: string };

const validate = (data: FormData, props) => {
    const errors: FormErrors<FormData> = {};

    if (!data.ico) {
        errors.ico = i18n(props.lang, "Validation_fieldRequired");
    }

    return errors;
};

class IcoInput extends Component<any> {

    constructor(props) {
        super(props);
    }

    render() {
        const {onClose, handleSubmit, submitting} = this.props;
        return (
            <div>
                <form.Form className={"edit-dialog-form"} horiznotal onSubmit={handleSubmit}>
                    <form.FormBody>
                        <h2 className={"mt-3 mb-3"}>{i18n(this.props.lang, "ProfilePage_pristupy_AddOSVC")}</h2>
                        <Card className="mb-3">
                            <CardBody>
                                <Label for={"ico"}>{i18n(this.props.lang, "SubjektForm_ico")}</Label>
                                <ff.String
                                    autoComplete={"off"}
                                    label={false}
                                    name={"ico"}
                                    disabled={submitting}
                                    required />
                            </CardBody>
                        </Card>
                    </form.FormBody>
                    <form.FormActions onClose={onClose} disabled={submitting} submitButton={false}>
                        <Button className={"pl-3 pr-3"} color="primary" outline onClick={onClose}>{i18n(this.props.lang, "button_cancel")}</Button>
                        <Button
                            className={"ml-2"}
                            color={"primary"}
                            type={"submit"}
                            disabled={submitting}
                        >
                            {i18n(this.props.lang, "ProfilePage_pristupyAddPristup")}
                        </Button>
                    </form.FormActions>
                </form.Form>
            </div>
        );
    }
}
const IcoInputForm = reduxForm<FormData, any>({
    form: "icoInput",
    validate: validate,
})(IcoInput);
export default withLang(IcoInputForm);
